import { render, staticRenderFns } from "./NanHaiMap.vue?vue&type=template&id=17667804&"
import script from "./NanHaiMap.vue?vue&type=script&lang=js&"
export * from "./NanHaiMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports